import { canAccessServiceRequestAttachment } from 'domains-work-order-authorization';
import { useTenantAdminCompanyRoleEnabled } from '../../feature-flags/useTenantAdminCompanyRoleEnabled';
import { useWoAttachmentsAuthorizationEnabled } from '../../feature-flags/useWoAttachmentsAuthorizationEnabled';
import { useActor } from '../authorization/useActor';
import {
  getAttachmentAccess,
  type AttachmentAccess,
} from './getAttachmentAccess';
import { toResource, type ServiceRequestRecord } from './toResource';

export const useServiceRequestAttachmentAccess = (
  record: ServiceRequestRecord
): AttachmentAccess => {
  const actor = useActor();
  const isEnforced = useWoAttachmentsAuthorizationEnabled();
  const companyRoleEnabled = useTenantAdminCompanyRoleEnabled();

  return getAttachmentAccess({
    actor,
    resource: toResource(record),
    isEnforced,
    canAccess: request =>
      canAccessServiceRequestAttachment(request, { companyRoleEnabled }),
  });
};
